import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const myPolicyDetailPageContext = React.createContext({});
export let myPolicyDetailPageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMmyPolicyDetailPage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  myPolicyDetailPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(myPolicyDetailPageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    myPolicyDetailPageMachine,
    myPolicyDetailPageState: state,
    myPolicyDetailPageSend: send,
  };
};
